//Please add the language resource
const sku = {
  skuCode:'SkuCode',
  skuNameZh: 'SkuNameZh',
  skuNameEn: 'SkuNameEn',
  skuDesc:'SkuDesc',
  skuType:'SkuType',
  length:'Length',
  width:'Width',
  height:'Height',
  volume: 'Volume',
  netWeight:'NetWeight',
  grossWeight:'GrossWeight',
  createTime:'CreateTime',
  creator:'Creator',
  updateTime:'UpdateTime',
  updater:'Updater',
  msg:{
  }
};
export default sku



// WEBPACK FOOTER //
// ./src/page/md/sku/lang/sku.en.js